import { CourseProgress } from 'graphqlAPI'

import ProgressPopover from '../../../../ProgressPopover'
import { CoursesProgress } from '../../components'

export const Progress: React.FC<{
  progress: CourseProgress
  id: string
}> = ({ progress, id }) => {
  return (
    <ProgressPopover id={id} progress={progress}>
      <CoursesProgress progress={[progress]} />
    </ProgressPopover>
  )
}

export default Progress
